
  import userController from '/home/builduser/work/92f03a7474915e95/packages/payment-methods-banner-ooi/src/components/PaymentMethodsBannerWidget/controller.ts';
  import createControllerWrapper from '@wix/yoshi-flow-editor/runtime/esm/pureControllerWrapper.js';

  
import wrapController from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/ooi';


  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
    DSN: 'https://3d2f0188674f41fb8de8550ccb4b08e5@sentry.wixpress.com/2306',
    id: 'undefined',
    projectName: 'payment-methods-banner-ooi',
    teamName: 'payments-checkout',
    errorMonitor: true,
  };

  var experimentsConfig = {"scopes":["payments-checkout"],"centralized":true};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/92f03a7474915e95/packages/payment-methods-banner-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var biConfig = null;

  var defaultTranslations = {"settings.design.logoTheme.light":"Light","settings.tabs.design":"Design","settings.design.logoTheme.dark":"Dark","settings.title":"Installment Payment Options","demoView.title":"or {installmentCount} interest-free payments of {currency}{amount} with","settings.design.textAlignmentTitle":"Alignment","settings.design.logoThemeTitle":"Logo appearance","settings.design.fontSettings":"Text font & color"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/92f03a7474915e95/packages/payment-methods-banner-ooi/target/generated/bi/createBILogger.ts';

  const controllerOptions = {
    sentryConfig,
    biConfig,
    fedopsConfig,
    experimentsConfig,
    biLogger,
    translationsConfig,
    persistentAcrossPages: false,
    appName: "payment-methods-banner-ooi",
    componentName: "PaymentMethodsBannerWidget",
    appDefinitionId: "df892fe9-626f-44c9-a328-e29f93880b38",
    componentId: "f6aa0c93-74ae-415c-a5e3-1bfc7c747bf4",
    projectName: "payment-methods-banner-ooi",
    defaultTranslations,
    multilingualDisabled,
    shouldUseEssentials: true,
    withErrorBoundary: false,
    localeDistPath: "assets/locales"
  };

  const _controller = createControllerWrapper(userController, controllerOptions, {
    initI18n,
    createHttpClient,
    createExperiments,
  });

  export const wrap = wrapController;
  export const descriptor = {
    ...controllerOptions,
    id: controllerOptions.componentId,
    widgetType: "WIDGET_OUT_OF_IFRAME",
    controllerFileName: "/home/builduser/work/92f03a7474915e95/packages/payment-methods-banner-ooi/src/components/PaymentMethodsBannerWidget/controller.ts",
  };

  export const controller = _controller
  export default controller;
